export const WsType = {
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
    NOTICE: 'NOTICE',
    READ: 'READ',
    WORKFLOW: 'WORKFLOW',
    FILE_ZIP: "FILE_ZIP",
    MEETING: 'MEETING',
    DOC_LOCK_CHANGE: 'DOC_LOCK_CHANGE',
    PROFILE_ANALYSIS: 'PROFILE_ANALYSIS',
    ANALYZE_RESUME: 'ANALYZE_RESUME'
}